import React, { Component } from "react";

export default class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <div className="footer-detail">
          Copyright © 2018 PorLor Express. All Rights Reserved.{" "}
        </div>
      </footer>
    );
  }
}
